import React, { useEffect } from 'react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Scrollbar from './components/ScrollBar';
import { hydrate } from "react-dom";
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';


const tagManagerArgs = {
    gtmId: 'GTM-MQ7T323H'
}

const disableGTM = false;

const GtmInit = () =>{
  useEffect(() => {
    if(window.location.hostname !== 'localhost' && !disableGTM){
      TagManager.initialize(tagManagerArgs);
    }
  },[]);
}


const rootElement = document.getElementById("root");
const root = createRoot(rootElement); 

const isDesktop = () => {
  return window.innerWidth >= 768; // Assuming md breakpoint is 768px
};

if (rootElement.hasChildNodes()) {
  hydrate(  
  <React.StrictMode>
    <Scrollbar/>
    <App />
    <GtmInit/>
  </React.StrictMode>, rootElement);
} else {
  root.render(  
  <React.StrictMode>
    <Scrollbar/>
    <App />
    <GtmInit/>
  </React.StrictMode>);
}

reportWebVitals();
